import {Box, Typography} from "@mui/material";
import React from "react";
import DenseTable from "../components/Table";
import CloseIcon from "@mui/icons-material/Close";

const CoinChannel = ({type, closeTable}) => {
  const positiveCard = type === "top" ? true : false;
  // console.log("params", params);
  return (
    <Box position="relative" maxWidth="900px" margin="20px auto">
      <Box
        display="flex"
        justifyContent="center"
        alignItems={"center"}
        sx={{
          // backgroundColor: "red",
          position: "relative",
        }}
      >
        <Typography sx={{fontWeight: "bold", textAlign: "center", marginTop: "50px", marginBottom: "30px"}} variant="h4">
          {positiveCard ? "Top 10 Coin-Channel" : "Bottom 10 Coin-Channel"}
        </Typography>
        <CloseIcon
          onClick={() => {
            closeTable();
          }}
          style={{
            alignSelf: "flex-end",
            position: "absolute",
            right: "0px",
            top: "45%",
            fontSize: "30px",
            cursor: "pointer",
          }}
        />
      </Box>

      <DenseTable positive={positiveCard} />
    </Box>
  );
};

export default CoinChannel;
